import { Box, Button, Grid2, MenuItem, Modal, Select, Snackbar, Switch, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import TokenError from "../tokenError";
import config from '../../config/config.js';
import {makeGetRequestToUrl} from '../commonFunc.jsx';
import {makePostRequestToUrl} from '../commonFunc.jsx';
import { useNavigate } from "react-router-dom";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 600,
    bgcolor: 'background.paper',
    border: '1px solid #000',
    boxShadow: 24,
    p: 4,
    borderRadius:'8px'
};

const TaxiCancellationReason = () => {

    const navigate = useNavigate();
    const [tokenExpired, setTokenExpired] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const token = localStorage.getItem('token');
    const cities = JSON.parse(localStorage.getItem('cities'));
    const [cityFilter, setCityFilter] = useState(cities[0].city_id);
    const serverUrl = config.serverUrl;
    const operationsUrl = config.operationsUrl;
    const [message, setMessage] = useState('');
    const [snackbar, showSnackbar] = useState(false);
    const [cancellationReasonsData, setCancellationReasonsData] = useState([]);
    const [allCancellationReasonsData, setAllCancellationReasonsData] = useState([]);
    const [rideTypeFilter, setRideTypeFilter] = useState('');
    const [userTypeFilter, setUserTypeFilter] = useState('1');
    const [openAddModal, setOpenAddModal] = useState(false);
    const [name, setName] = useState('');
    const [error, setError] = useState('');
    const [cancelId, setCancelId] = useState('');
    const [rideType, setRideType] = useState('');

    const handleCityChange = (e) =>{
        const city =  cities.find((cityObj) => cityObj.city_id === e)
        setCityFilter(e);
        setRideTypeFilter('');
    }


    const handleRideTypeChange = (e) =>{
        setRideTypeFilter(e);
        if (e === '') {
            setCancellationReasonsData(allCancellationReasonsData);
        } else {
            const filteredData = allCancellationReasonsData.filter((item) => item.ride_type == e);
            setCancellationReasonsData(filteredData);
        }
    }

    const fetchCancellationReasonsData = async() => {
        try {
            const url = serverUrl + '/panel/fetch_cancellation_reason';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                city_id: cityFilter,
                user_type: userTypeFilter,
                timestamp: timestamp
            };
            const response =  await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                setAllCancellationReasonsData(response.data);
                setCancellationReasonsData(response.data);
            }
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            }
        } 
        catch (error) {
            console.log('error', error);
        }
    }

    const setEnabled = async(id, val) => {
        // console.log('id= ', id, 'and val= ', val);
        try {
            const token = localStorage.getItem('token');
            const body = {
                token: token,
                // name: name,
                is_active: val,
                city_id: cityFilter,
                id: id
            };

            const response = await fetch(operationsUrl + '/client/add_update_cancellation_reason', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(body)
            });
            const data = await response.json();

            if (data.flag==200) {
                handleClose();
                fetchCancellationReasonsData();
                setMessage(data.message);
                showSnackbar(true);
            } 
            else {
                setError(data.message || 'Login failed. Please try again.');
            }
        } catch (error) {
            setError('An error occurred. Please try again later.');
        }
    }

    useEffect(() => {
        fetchCancellationReasonsData();
    }, [cityFilter, userTypeFilter]);

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return; 
        }
        showSnackbar(false); 
    };

    const handleOpenAddModal = () => {
        setOpenAddModal(true);
        setName('');
        setCancelId('');
        setRideType('');
    }

    const handleClose = () => {
        setOpenAddModal(false);
    }

    const saveCategory = async() => {
        if(!name) {
            setMessage('Please enter cancellation reason name.');
            showSnackbar(true);
            return;
        }
        if(!rideType) {
            setMessage('Please select ride type.');
            showSnackbar(true);
            return;
        }
        try {
            const token = localStorage.getItem('token');
            const body = {
                token: token,
                name: name,
                ride_type: rideType,
                user_type: userTypeFilter,
                city_id: cityFilter
            };
            if(cancelId!=''){
                body.id=cancelId;
            }

            const response = await fetch(operationsUrl + '/client/add_update_cancellation_reason', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(body)
            });
            const data = await response.json();

            if (data.flag==200) {
                handleClose();
                fetchCancellationReasonsData();
                setMessage(data.message);
                showSnackbar(true);
            } 
            else {
                setMessage(data.message);
                showSnackbar(true);
            }
        } catch (error) {
            setError('An error occurred. Please try again later.');
        }
    }

    const handleOpenEdit = (row) =>{
        // setOpenEditModal(true);
        setCancelId(row.id);
        setRideType(row.ride_type);
        setOpenAddModal(true);
        setName(row.name);
    }

    return (
        <div>
            {tokenExpired && (<TokenError/>)}
            
            <Typography style={{ fontSize: '28px', fontWeight: '500' }}>Cancellation Reasons</Typography>

            <Grid2 item container spacing={2} sx={{marginTop:'2%'}}>
                <Grid2 item>
                    <Select value={cityFilter} 
                    onChange={(e) => handleCityChange(e.target.value)} displayEmpty
                    style={{width: '190px',height:'50px',borderRadius:'8px',backgroundColor: cityFilter ? '#F9F9F9' : '#FFFFFF'}}>
                        <MenuItem value="" disabled>Select City</MenuItem>
                        {cities.map((city) => (
                            <MenuItem key={city.city_name} value={city.city_id}>
                                {city.city_name}
                            </MenuItem>
                        ))}
                    </Select>
                </Grid2>

                <Grid2 item>
                    <Select value={userTypeFilter} displayEmpty
                    onChange={(e) => {
                        setUserTypeFilter(e.target.value)
                        setRideTypeFilter('')
                    }} 
                    style={{width: '190px',height:'50px',borderRadius:'8px',backgroundColor: '#f9f9f9'}}>
                        {/* <MenuItem value="">Select User Type</MenuItem> */}
                        <MenuItem value="1">Customer</MenuItem>
                        <MenuItem value="2">Driver</MenuItem>
                    </Select>
                </Grid2>

                <Grid2 item>
                    <Select value={rideTypeFilter} 
                    onChange={(e) => handleRideTypeChange(e.target.value)} displayEmpty
                    style={{width: '190px',height:'50px',borderRadius:'8px',backgroundColor: rideTypeFilter ? '#F9F9F9' : '#FFFFFF'}}>
                        <MenuItem value="">Select Ride Type</MenuItem>
                        <MenuItem value="1">Scheduled Ride</MenuItem>
                        <MenuItem value="2">On Demand (Before Arrived)</MenuItem>
                        <MenuItem value="3">On Demand (After Arrived)</MenuItem>
                    </Select>
                </Grid2>

                <Grid2 item>
                    <Button
                        variant="contained"
                        onClick={handleOpenAddModal}
                        style={{width:'190px', height:'50px', backgroundColor:'#000000', textTransform:'none', borderRadius:'8px'}}>
                        + Add Reason
                    </Button>
                </Grid2>
            </Grid2>

            <Modal open={openAddModal} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                <Box sx={style}>
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                        Add Reason
                    </Typography>
                    <hr/>
                    <Grid2 id="modal-modal-description" sx={{ mt: 6 }}>
                        <Grid2 item container size={12} sx={{ marginTop:'6%'}}>
                            <Grid2 item size={2.5}>
                                <Typography>Name</Typography>
                            </Grid2>
                            <Grid2 item size={1}><Typography sx={{marginLeft:'4%'}}>:</Typography></Grid2>
                            <Grid2 item size={7.5}>
                                <TextField size="small"type="text" value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    sx={{ height:'30px', marginLeft:'4%' }} fullWidth
                                />
                            </Grid2>
                        </Grid2>

                        <Grid2 item container size={12} sx={{ marginTop:'6%'}}>
                            <Grid2 item size={2.5}>
                                <Typography>Ride Type</Typography>
                            </Grid2>
                            <Grid2 item size={1}><Typography sx={{marginLeft:'4%'}}>:</Typography></Grid2>
                            <Grid2 item size={7.5}>
                                <Select
                                    value={rideType} 
                                    fullWidth
                                    onChange={(e) => setRideType( e.target.value)}
                                    style={{ height: '40px', backgroundColor: '#FFFFFF', marginLeft:'4%'}}>
                                    <MenuItem value="">Ride Type</MenuItem>
                                    <MenuItem value="1">Scheduled Ride</MenuItem>
                                    <MenuItem value="2">On Demand (Before Arrived)</MenuItem>
                                    <MenuItem value="3">On Demand (After Arrived)</MenuItem>
                                </Select>
                            </Grid2>
                        </Grid2>

                        <Grid2 container spacing={2} sx={{ marginTop:'10%', marginBottom:'2%', justifyContent:'center'}}>
                            <Grid2 item ><Button variant="contained" sx={{width:'120px', textTransform:'none'}} onClick={saveCategory}>Save</Button></Grid2>
                            <Grid2 item ><Button onClick={handleClose} variant="contained" color="error"  sx={{width:'120px', textTransform:'none'}}>Cancel</Button></Grid2>
                        </Grid2>
                    </Grid2>
                </Box>
            </Modal>

            <TableContainer className="table-container" sx={{ maxHeight:'70vh' }}>
                <Table stickyHeader className="scrollable-table">
                    <TableHead>
                        <TableRow>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>ID</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Name</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Ride Type</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Status</TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Action</TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {cancellationReasonsData.length === 0 ? (
                            <TableRow>
                                <TableCell colSpan={13} align="center">
                                    <Typography variant="body1">No data found</Typography>
                                </TableCell>
                            </TableRow>
                        ) : (
                            cancellationReasonsData.map((row) => {

                            return(
                                <TableRow key={row.id}>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.id}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.name}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.ride_type==1 ? 'Scheduled Ride' : row.ride_type==2 ? 'On Demand (Before Arrived)' : 'On Demand (After Arrived)'}</Typography></TableCell>
                                    {/* <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '120px', color: row.is_active === 1 ? '#0DBA78' : '#D14545', fontWeight:'500'  }}>{row.is_active==1 ? 'Active' : 'Inactive'}</Typography></TableCell> */}
                                    <TableCell align="center">
                                        <div style={{ display: 'flex', justifyContent:'center'}}>
                                            <Button variant="contained" onClick={() => setEnabled(row.id,1)}
                                                style={{
                                                    backgroundColor: row.is_active ? '#0DBA78' : '#F4F4F4', minWidth: '80px',padding: '6px 16px',
                                                    color:row.is_active?'#FFFFFF':'#9E9E9E',textTransform:'none',borderRadius:'8px 0 0 8px', boxShadow: 'none',
                                                }}
                                            >
                                                Enable
                                            </Button>
                                            <Button variant="contained" onClick={() => setEnabled(row.id, 0)}
                                                style={{
                                                    backgroundColor: !row.is_active ? '#D14545' : '#F4F4F4', color: !row.is_active ? '#FFFFFF' : '#9E9E9E',
                                                    textTransform:'none', borderRadius:'0 8px 8px 0', boxShadow:'none',padding:'6px 16px', minWidth:'80px',
                                                }}
                                            >
                                                Disable
                                            </Button>
                                        </div>
                                    </TableCell>

                                    <TableCell align="center">
                                        <Button
                                            variant="contained"
                                            onClick={() => handleOpenEdit(row)}
                                            sx={{
                                                backgroundColor: '#EFFBF7', color: '#0DBA78', border: '1px solid #0DBA78', textTransform: 'none',
                                                borderRadius: '8px', minWidth:'40px', boxShadow:'none', width:"90px",
                                                '&:hover': {backgroundColor: '#0DBA78', color: 'white'},
                                                '&:active': { backgroundColor: '#0DBA78', color: 'white'}
                                            }}>
                                            
                                            <Typography sx={{marginRight:'6%'}}>Edit</Typography>
                                            <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M4.84304 9.45074L5.39054 6.89324C5.47025 6.53784 5.64979 6.21258 5.90804 5.95574L10.9105 0.998238C11.4178 0.481469 12.1066 0.182825 12.8305 0.165738C13.3765 0.157914 13.9031 0.368518 14.293 0.750738C15.1452 1.75759 15.0352 3.26115 14.0455 4.13324L9.04304 9.13574C8.7862 9.39399 8.46095 9.57353 8.10554 9.65324L5.54804 10.2007H5.40554C5.21858 10.2079 5.04 10.1228 4.92774 9.97316C4.81547 9.82347 4.78382 9.62822 4.84304 9.45074ZM6.70304 6.75824C6.59796 6.86007 6.52496 6.99043 6.49304 7.13324L6.12554 8.88074L7.87304 8.50574C8.01585 8.47382 8.14621 8.40082 8.24804 8.29574L13.2505 3.29324C13.7986 2.85451 13.9073 2.0636 13.498 1.49324C13.3188 1.32202 13.0783 1.23012 12.8305 1.23824C12.4035 1.25539 11.9999 1.43834 11.7055 1.74824L6.70304 6.75824Z" fill="currentColor"/>
                                                <path d="M13.933 6.19574C13.6241 6.19978 13.3746 6.44927 13.3705 6.75824V11.0257C13.3806 11.6289 13.148 12.2109 12.7249 12.641C12.3019 13.0711 11.7238 13.3133 11.1205 13.3132H3.97305C2.72607 13.2888 1.72688 12.2729 1.72305 11.0257V3.90824C1.74352 2.65955 2.7617 1.65807 4.01055 1.65824H8.27805C8.58871 1.65824 8.84055 1.4064 8.84055 1.09574C8.84055 0.785078 8.58871 0.533238 8.27805 0.533238H3.97305C2.10292 0.533125 0.581098 2.03823 0.560547 3.90824V11.0257C0.560547 12.9104 2.08838 14.4382 3.97305 14.4382H11.0905C12.9723 14.4341 14.4956 12.9075 14.4955 11.0257V6.75824C14.4915 6.44927 14.242 6.19978 13.933 6.19574Z" fill="currentColor"/>
                                            </svg>
                                        </Button>
                                    </TableCell>
                                </TableRow>
                            )
                        })
                        )}
                    </TableBody>
                </Table>
            </TableContainer>


            <Snackbar open={snackbar} autoHideDuration={2000} onClose={handleSnackbarClose} message={message}></Snackbar>

        </div>
    )
}

export default TaxiCancellationReason;